export const filters = () => {
  const filters_container = document.querySelector('.formules-filters');
  if (filters_container) {
    const users_inputs = filters_container.querySelectorAll('[name="users"]');
    const invoices_input = filters_container.querySelector('[name="invoices"]');
    const horus_input = filters_container.querySelectorAll('[name="horus"]');

    users_inputs.forEach(input => {
      input.addEventListener('change', () => {
        set_active_filters(input);
        filters_calculation();
      });
    });

    invoices_input.addEventListener('change', () => {
      filters_calculation();
    });

    horus_input.forEach(input => {
      input.addEventListener('change', () => {
        set_active_filters(input);
        filters_calculation();
      });
    });

    filters_calculation();
  }

  const compare_formules_container = document.querySelector('.compare-filters');

  let compare_first;
  let compare_second;

  if (compare_formules_container) {
    compare_first = compare_formules_container.querySelector('[name="compare_first"]');
    compare_second = compare_formules_container.querySelector('[name="compare_second"]');

    compare_first.addEventListener('change', () => {
      compare_formules();
    });

    compare_second.addEventListener('change', () => {
      compare_formules();
    });
  }

  const type_selector_container = document.querySelector('.formules-type-selector');

  if (type_selector_container) {
    type_selector_container.querySelectorAll('[name="type"]').forEach(input => {
      input.addEventListener('change', () => {
        const type = input.value;

        set_active_filters(input);
        set_type_filters(type);

        if (compare_first && compare_second) {
          compare_first.querySelector(`option:not([hidden]):not([disabled])`).selected = true;
          compare_second.querySelector(`option:not([hidden]):not([disabled]):not([value="${compare_first.value}"])`).selected = true;
        }

        compare_first.dispatchEvent(new Event('change'));
        compare_second.dispatchEvent(new Event('change'));
      });
    });

    if (type_selector_container.querySelector('[name="type"]:checked')) {
      set_type_filters(type_selector_container.querySelector('[name="type"]:checked').value);
    }
  }

  compare_formules();

  const subscriptions_type = document.querySelectorAll('[name="subscriptions_type"]');
  subscriptions_type.forEach(input => {
    input.addEventListener('change', () => {
      const type = input.value;
      set_active_filters(input);

      document.querySelectorAll('[data-subscriptions-type]').forEach(subscriptions_type_element => {
        if (subscriptions_type_element.dataset.subscriptionsType == type) {
          subscriptions_type_element.classList.remove('hidden');
        } else {
          subscriptions_type_element.classList.add('hidden');
        }
      });

      updateVisibleRowsOpacity();
    });
  });
};

const set_type_filters = (type) => {
  document.querySelectorAll('[data-type]').forEach(type_element => {
    if (type_element.dataset.type == type) {
      type_element.classList.remove('hidden');
      type_element.removeAttribute('hidden');
      type_element.removeAttribute('disabled');
    } else {
      type_element.classList.add('hidden');
      type_element.setAttribute('hidden', '');
      type_element.setAttribute('disabled', '');
    }
  });

  updateVisibleRowsOpacity();
};

const filters_calculation = () => {
  if (typeof formules_data != "undefined") {
    const user = document.querySelector('[name="users"]:checked').value;
    const invoice = document.querySelector('[name="invoices"]').value;
    const horus = document.querySelector('[name="horus"]:checked').value;

    let result = formules_data.filter(formule => formule.invoices >= parseInt(invoice));
    result = result.filter(formule => formule.users >= parseInt(user));

    console.log(invoice, user, horus);

    if (horus == 'no') {
      document.querySelectorAll('.horus').forEach(el => el.classList.add('hidden'));
      const summary_extra = document.querySelector('.show--extra');
      if (summary_extra) {
        const details = summary_extra.closest('details');
        details.open = true;
        details_extra_clicked(details);
      }
    } else {
      document.querySelectorAll('.horus').forEach(el => el.classList.remove('hidden'));
      const summary_extra = document.querySelector('.show--extra');
      if (summary_extra) {
        const details = summary_extra.closest('details');
        details.open = false;
        details_extra_clicked(details);
      }
    }

    let formules = formules_data[0];
    if (result.length > 0) {
      formules = result[0];
    }

    document.querySelectorAll('[data-formule-id]').forEach(el => {
      el.classList.add('hidden');
      el.classList.remove('highlight', 'result');
    });

    let _count = 0;
    formules.formules.forEach(formule_id => {
      document.querySelectorAll(`[data-formule-id="${formule_id}"]`).forEach(el => {
        el.classList.remove('hidden');
        if (_count < 2) el.classList.add('result');
      });
      _count++;
    });

    document.querySelectorAll(`[data-formule-id="${formules.highlight}"]`).forEach(el => {
      el.classList.add('highlight');
    });

    updateVisibleRowsOpacity();
  }
};

export const set_active_filters = (input) => {
  const container = input.closest('.falco-filters');
  const parent_label = input.closest('.btn-filter');

  let left = 0;
  let top = 0;
  let height = null;
  let width = null;
  let found = false;

  container.querySelectorAll('.btn-filter').forEach(btn => {
    btn.classList.remove('active');
    if (btn == parent_label) {
      width = btn.offsetWidth;
      height = btn.offsetHeight;
      found = true;
    }

    if (!found) {
      left += btn.offsetWidth;
      top += btn.offsetWidth;
    }
  });

  parent_label.classList.add('active');
  const index = get_child_index(input.closest('.btn-filter'));
  container.style.setProperty('--filter-left', `${left}px`);
  container.style.setProperty('--filter-width', `${width}px`);
  container.style.setProperty('--filter-top', `${top}px`);
  container.style.setProperty('--filters-index', index);
};

const get_child_index = (node) => {
  return Array.prototype.indexOf.call(node.parentNode.children, node);
};

const compare_formules = () => {
  const compare_container = document.querySelector('.compare-filters');
  const type = document.querySelector('[name="type"]:checked');

  if (compare_container && !compare_container.checkVisibility({ contentVisibilityAuto: true })) {
    let type_type = 'essentiel';
    if (type) {
      type_type = type.value
    };

    document.querySelectorAll(`[data-formule-id][data-type="${type_type}"]`).forEach(el => {
      el.classList.add('hidden');
      el.setAttribute('hidden', true);
    });

    document.querySelectorAll(`[data-formule-id][data-type="${type_type}"]`).forEach(el => {
      el.classList.remove('hidden');
      el.removeAttribute('hidden');
    });

    updateVisibleRowsOpacity();
    return;
  }

  const compare_first = document.querySelector('[name="compare_first"]');
  const compare_second = document.querySelector('[name="compare_second"]');

  if (compare_first && compare_second) {
    compare_first.querySelectorAll(`option:not([hidden])`).forEach(option => {
      option.removeAttribute('disabled');
    });

    compare_second.querySelectorAll(`option:not([hidden])`).forEach(option => {
      option.removeAttribute('disabled');
    });
    document.querySelectorAll('[data-formule-id]').forEach(el => {
      if (
        el.dataset.formuleId == compare_first.value ||
        el.dataset.formuleId == compare_second.value
      ) {
        el.classList.remove('hidden');
        el.classList.add('result');
        el.removeAttribute('hidden');
      } else {
        el.classList.add('hidden');
        el.classList.remove('result');
        el.setAttribute('hidden', true);
      }
    });

    // Empêche la sélection du même élément dans les deux listes
    compare_first.querySelectorAll(`option[value="${compare_second.value}"]`).forEach(option => {
      option.setAttribute('disabled', '');
    });

    compare_second.querySelectorAll(`option[value="${compare_first.value}"]`).forEach(option => {
      option.setAttribute('disabled', '');
    });

    updateVisibleRowsOpacity();
  }
};

export const details_extra = () => {
  const summary_extra = document.querySelector('.show--extra');
  if (summary_extra) {
    const details = summary_extra.closest('details');
    details.addEventListener('toggle', () => {
      details_extra_clicked(details);
    });
  }
};

export const details_extra_clicked = (details) => {
  if (details) {
    const last_row = document.querySelector(details.open ? '.last-row' : '.last-row-no-horus');
    if (last_row) {
      last_row.classList.toggle('last-row-no-horus');
      last_row.classList.toggle('last-row');
    }
  }
};

function updateVisibleRowsOpacity() {
  const rows = Array.from(document.querySelectorAll('.formules-table__line'))
    .filter(row => !row.classList.contains('hidden') && row.offsetParent !== null);

  const total = rows.length;

  rows.forEach((row, index) => {
    const opacity = Math.max(0.3, 1 - (index / total));
    row.style.setProperty('--opacity', opacity.toFixed(2));
  });
}
